import React from 'react';

export const SalesTeamPerformanceSection = ({ salesTeam = [] }) => {
  return (
    <div className="card p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-slate-800 font-sans tracking-tight">
            Top 5 Sales Performers
          </h3>
          <p className="text-xs text-slate-400 mt-0.5">Current month performance</p>
        </div>
        <div className="flex items-center gap-4 text-[11px] text-slate-400 font-medium">
        </div>
      </div>

      {/* Team Members */}
      <div className="space-y-5">
        {salesTeam.map((member, idx) => {
          const conversionRate = member.totalLeads > 0 
            ? Math.round((member.converted / member.totalLeads) * 100) 
            : 0;
          const isTop = idx === 0 && member.converted > 0;

          return (
            <div key={member._id}>
              <div className="flex items-center justify-between mb-1.5">
                {/* Left: Avatar + Name + Contact + Leads */}
                <div className="flex items-center gap-4">
                  <div className="w-8 h-8 shadow-sm rounded-full flex items-center justify-center text-white font-bold text-xs shrink-0 bg-gradient-to-br from-orange-400 to-blum-orange">
                    {member.name.charAt(0).toUpperCase()}
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="text-brand-dark tracking-tight text-[13px] leading-tight truncate">{member.name}</span>
                      {isTop && (
                        <span className="text-[9px] font-bold uppercase tracking-wider bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded-full">
                          Top Performer
                        </span>
                      )}
                    </div>
                    {/* Phone & Email line */}
                    {(member.phone || member.email) && (
                      <div className="text-[10px] text-slate-400 truncate flex items-center mt-0.5 tracking-tighter mb-1">
                        {member.phone && <span>{member.phone}</span>}
                        {member.phone && member.email && <span className="opacity-50 mx-1.5">|</span>}
                        {member.email && <span>{member.email.toLowerCase()}</span>}
                      </div>
                    )}
                    {/* Leads Breakdown */}
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="text-[11px] font-medium text-slate-500">
                        {member.totalLeads} Leads
                      </span>
                      <span className="text-slate-300 text-[10px]">•</span>
                      <span className="text-[11px] font-medium text-amber-600">
                        {member.pending} Pending
                      </span>
                      <span className="text-slate-300 text-[10px]">•</span>
                      <span className="text-[11px] font-medium text-emerald-600">
                        {member.converted} Converted
                      </span>
                    </div>
                  </div>
                </div>

                {/* Right: Conversion */}
                <div className="text-right shrink-0">
                  <div className="text-[13px] font-bold text-slate-900 mt-0.5">
                    {conversionRate}% conversion
                  </div>
                </div>
              </div>

              {idx < salesTeam.length - 1 && <div className="border-b border-slate-100 mt-4" />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

